<template>
  <div class="bg-light">
    <top-bar @reload="acessarEmpresa()"/>
    <div class="content" v-if="usuario.habilitar_comanda === '1'">
      <div class="container-home">
        <div class="container-fluid">
          <h6 class="font-weight-bold mb-2 small">Acesso Rápido</h6>
          <div class="row">
            <div class="col-md-3 mb-3">
              <router-link class="card quick-access-card text-decoration-none text-white bg-primary" to="/pdv">
                <div class="card-body d-flex align-items-center">
                <span class="quick-access-icon rounded-sm d-md-none d-lg-flex">
                  <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-building-store" width="32" height="32" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fff" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <line x1="3" y1="21" x2="21" y2="21" />
                    <path d="M3 7v1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1h-18l2 -4h14l2 4" />
                    <line x1="5" y1="21" x2="5" y2="10.85" />
                    <line x1="19" y1="21" x2="19" y2="10.85" />
                    <path d="M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4" />
                  </svg>
                </span>
                  <div class="ml-3 ml-md-0 ml-lg-3">
                    <p class="small mb-1 text-nowrap">Frente de Caixa</p>
                    <h6 class="font-weight-bold m-0">PDV</h6>
                  </div>
                </div>
              </router-link>
            </div>
            <div class="col-md-3 mb-3 d-md-none" v-if="showPedidos && !isComanda">
              <router-link class="card quick-access-card text-decoration-none text-white bg-success" to="/pedidos">
                <div class="card-body d-flex align-items-center">
                <span class="quick-access-icon rounded-sm d-md-none d-lg-flex">
                  <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-notes" width="32" height="32" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fff" fill="none" stroke-linecap="round" stroke-linejoin="round">
                     <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                     <path d="M5 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"></path>
                     <path d="M9 7l6 0"></path>
                     <path d="M9 11l6 0"></path>
                     <path d="M9 15l4 0"></path>
                  </svg>
                </span>
                  <div class="ml-3 ml-md-0 ml-lg-3">
                    <p class="small mb-1 text-nowrap">Gestor de Pedidos</p>
                    <h6 class="font-weight-bold m-0">Pedidos</h6>
                  </div>
                </div>
              </router-link>
            </div>
            <div class="col-md-3 mb-3" v-if="usuario.admin">
              <router-link class="card quick-access-card text-decoration-none text-white bg-secondary" to="/home/caixas">
                <div class="card-body d-flex align-items-center">
                <span class="quick-access-icon rounded-sm d-md-none d-lg-flex">
                  <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-coin" width="32" height="32" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fff" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <circle cx="12" cy="12" r="9" />
                    <path d="M14.8 9a2 2 0 0 0 -1.8 -1h-2a2 2 0 0 0 0 4h2a2 2 0 0 1 0 4h-2a2 2 0 0 1 -1.8 -1" />
                    <path d="M12 6v2m0 8v2" />
                  </svg>
                </span>
                  <div class="ml-3 ml-md-0 ml-lg-3">
                    <p class="small mb-1 text-nowrap">Gerenciar Caixas</p>
                    <h6 class="font-weight-bold m-0">Caixas</h6>
                  </div>
                </div>
              </router-link>
            </div>
            <div class="col-md-3 mb-3" v-if="usuario.admin">
              <router-link class="card quick-access-card text-decoration-none text-white bg-info" to="/home/relatorios">
                <div class="card-body d-flex align-items-center">
                <span class="quick-access-icon rounded-sm d-md-none d-lg-flex">
                  <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-chart-bar" width="32" height="32" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fff" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <rect x="3" y="12" width="6" height="8" rx="1" />
                    <rect x="9" y="8" width="6" height="12" rx="1" />
                    <rect x="15" y="4" width="6" height="16" rx="1" />
                    <line x1="4" y1="20" x2="18" y2="20" />
                  </svg>
                </span>
                  <div class="ml-3 ml-md-0 ml-lg-3">
                    <p class="small mb-1">Administrativo</p>
                    <h6 class="font-weight-bold m-0">Relatórios</h6>
                  </div>
                </div>
              </router-link>
            </div>
            <div class="col-md-3 mb-3">
              <router-link class="card quick-access-card text-decoration-none text-white bg-warning" to="/terminal">
                <div class="card-body d-flex align-items-center">
                <span class="quick-access-icon rounded-sm d-md-none d-lg-flex">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" width="32" height="32" stroke-width="1.5"> <path d="M3 5a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-10z"></path> <path d="M7 20h10"></path> <path d="M9 16v4"></path> <path d="M15 16v4"></path> </svg>
                </span>
                  <div class="ml-3 ml-md-0 ml-lg-3">
                    <p class="small mb-1">Cozinha</p>
                    <h6 class="font-weight-bold m-0">Monitor KDS</h6>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
          <div class="mt-3">
            <relatorios ref="rel" isComponente="true"/>
          </div>
        </div>
      </div>
    </div>
    <upgrade v-else/>
  </div>
</template>

<script>
  import TopBar from "@/components/commons/TopBar";
  import Relatorios from "@/views/comanda/Relatorios";
  import Upgrade from "@/views/Upgrade";

  export default {
    name: 'HomePdv',
    components: {Upgrade, Relatorios, TopBar},

    data() {
      return {
        showPedidos: false
      }
    },

    mounted() {
      if (this.usuario.id_funcao < 2 || !this.isReadOnly) {
        this.showPedidos = !this.isComanda && !this.isReadOnly;
        this.$helpers.toggleModal(false);

      } else {
        this.$router.push('/pdv');
      }
    },

    methods: {
      acessarEmpresa() {
        sessionStorage.removeItem('cache_home');
        this.$refs.rel.changeEmpresa();
      }
    },

    computed: {
      usuario() {
        return this.$store.state.dataUser
      },

      isComanda() {
        return this.$store.state.is_comanda;
      },

      isReadOnly() {
        return this.$store.state.isReadOnly;
      }
    }
  }
</script>
<style scoped>
  .card {
    border-radius: 16px;
    border: none;
  }

  .card .card-body {
    padding: 18px;
  }

  .quick-access-card {
    min-height: 84px;
    height: 100%;
  }

  .quick-access-icon {
    display: flex;
    flex: 0 0 48px;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    background-color: rgba(0, 0, 0, 0.1);
  }

  .quick-access-card:hover .quick-access-icon {
    background-color: transparent;
  }

  .quick-access-icon svg {
    display: block;
    width: 32px;
    height: 32px;
  }

  .container-home {
    background-color: var(--light);
    border-radius: 24px;
    padding-top: 26px;
    margin: 12px 0;
  }

  @media (max-width: 767px) {
    .quick-access-card {
      min-height: 74px;
    }

    .card .card-body {
      padding: 13px;
    }

    /*.container-home {*/
    /*  border-radius: 0;*/
    /*  margin: 0;*/
    /*}*/
  }
</style>
